import { useTranslation } from "react-i18next";
import Question, { QuestionProps } from "./Question";
import Tooltip from "@/Components/Tooltip/Tooltip";

export interface UserHelperProps extends QuestionProps {
  usePublic?: boolean;
  useDaily?: boolean;
  useCourier?: boolean;
  useRemark?: boolean;
}

const UserHelper = ({
  usePublic = true,
  useDaily = true,
  useCourier = true,
  useRemark = true,
  ...props
}: UserHelperProps) => {
  const { t } = useTranslation("");
  return (
    <Tooltip
      maxWidth={500}
      content={
        <ul style={{ minWidth: "20rem", padding: "1rem", margin: 0 }}>
          {usePublic && <li>{t("use&ForPublicOrderNumber")}</li>}
          {useDaily && <li>{t("use#ForDailyReceipt")}</li>}
          {useCourier && <li>{t("use@ForCourier")}</li>}
          {useRemark && <li>{t("use!ForRemark")}</li>}
        </ul>
      }
    >
      <div>
        <Question {...props} />
      </div>
    </Tooltip>
  );
};

export default UserHelper;
